import { useState } from "react";
import { Row, Col, Label, Form, FormGroup, Input, Container } from "reactstrap";
import { ESTADOS } from "../shared/EstadosMexico";

const initialContactData = {
    nombres: '',
    apellidoPaterno: '',
    apellidoMaterno: '',
    fechaNacimiento: '',
    ciudad: '',
    estado: '',
    horarioContactoPreferente: '',
    correoRecuperacion: '',
    telefono: '',
    telefonoSecundario: ''
};

export default function Contacto() {
    const [contactData, setContactData] = useState(initialContactData);

    function handleChange(name) {
        return function (e) {
            setContactData({ ...contactData, [name]: e.target.value });
        };
    }

    return (
        <div>
            <h3>Contacto</h3>
            <Row>
                <p>Permitenos brindarte una experiencia de usuario optima en nuestra plataforma, proporcionanos tus datos de contacto.</p>
            </Row>
            <Form>
                <FormGroup>
                    <Container fluid className="px-0">
                        <Row>
                            <Col xs="3">
                                <Label for="nombres">Nombres *</Label>
                            </Col>
                            <Col xs="auto">
                                <Input
                                    type="text"
                                    id="nombres"
                                    name="nombres"
                                    className="FormInput"
                                    value={contactData.nombres}
                                    onChange={handleChange('nombres')}
                                    required
                                />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col xs="3">
                                <Label for="apellidoPaterno">Apellido Paterno *</Label>
                            </Col>
                            <Col xs="auto">
                                <Input
                                    type="text"
                                    id="apellidoPaterno"
                                    name="apellidoPaterno"
                                    className="FormInput"
                                    value={contactData.apellidoPaterno}
                                    onChange={handleChange('apellidoPaterno')}
                                    required
                                />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col xs="3">
                                <Label for="apellidoMaterno">Apellido Materno</Label>
                            </Col>
                            <Col xs="auto">
                                <Input
                                    type="text"
                                    id="apellidoMaterno"
                                    name="apellidoMaterno"
                                    className="FormInput"
                                    value={contactData.apellidoMaterno}
                                    onChange={handleChange('apellidoMaterno')}
                                />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col xs="3">
                                <Label for="fechaNacimiento">Fecha de nacimiento</Label>
                            </Col>
                            <Col xs="auto">
                                <Input
                                    type="date"
                                    id="fechaNacimiento"
                                    name="fechaNacimiento"
                                    className="FormInput"
                                    value={contactData.fechaNacimiento}
                                    onChange={handleChange('fechaNacimiento')}
                                />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col xs="3">
                                <Label for="ciudad">Ciudad</Label>
                            </Col>
                            <Col xs="auto">
                                <Input
                                    type="text"
                                    id="ciudad"
                                    name="ciudad"
                                    className="FormInput"
                                    value={contactData.ciudad}
                                    onChange={handleChange('ciudad')}
                                />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col xs="3">
                                <Label for="estado">Estado</Label>
                            </Col>
                            <Col xs="auto">
                                <Input
                                    type="select"
                                    id="estado"
                                    name="estado"
                                    className="FormInput"
                                    value={contactData.estado}
                                    onChange={handleChange('estado')}
                                >
                                    <option value="">Seleccionar...</option>
                                    {ESTADOS.map((estado) => (
                                        <option key={estado} value={estado}>{estado}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col xs="3">
                                <Label for="horarioContactoPreferente">Horario de contacto preferente</Label>
                            </Col>
                            <Col xs="auto">
                                <Input
                                    type="time"
                                    id="horarioContactoPreferente"
                                    name="horarioContactoPreferente"
                                    className="FormInput"
                                    value={contactData.horarioContactoPreferente}
                                    onChange={handleChange('horarioContactoPreferente')}
                                />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col xs="3">
                                <Label for="correoRecuperacion">Correo electrónico de recuperación</Label>
                            </Col>
                            <Col xs="auto">
                                <Input
                                    type="email"
                                    id="correoRecuperacion"
                                    name="correoRecuperacion"
                                    className="FormInput"
                                    value={contactData.correoRecuperacion}
                                    onChange={handleChange('correoRecuperacion')}
                                />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col xs="3">
                                <Label for="telefono">Teléfono</Label>
                            </Col>
                            <Col xs="auto">
                                <Input
                                    type="tel"
                                    id="telefono"
                                    name="telefono"
                                    className="FormInput"
                                    value={contactData.telefono}
                                    onChange={handleChange('telefono')}
                                />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col xs="3">
                                <Label for="telefonoSecundario">Teléfono secundario</Label>
                            </Col>
                            <Col xs="auto">
                                <Input
                                    type="tel"
                                    id="telefonoSecundario"
                                    name="telefonoSecundario"
                                    className="FormInput"
                                    value={contactData.telefonoSecundario}
                                    onChange={handleChange('telefonoSecundario')}
                                />
                            </Col>
                        </Row>
                    </Container>
                </FormGroup>
            </Form>
        </div>
    );
}
